import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { RECOMMEND_SEARCH_WORD_PAGE_NAME } from '../../../constants/service/app/recommendSearchWordConstants';
import RecommendSearchWordDetailContainer from '../../../containers/recommend/searchWord/RecommendSearchWordDetailContainer';

const RecommendSearchWordDetail = () => {
  return (
    <PageTemplate pageName={RECOMMEND_SEARCH_WORD_PAGE_NAME.RECOMMEND_SEARCH_WORD_DETAIL}>
      <RecommendSearchWordDetailContainer />
    </PageTemplate>
  );
};

export default RecommendSearchWordDetail;
